/** "just now", "5 min ago", "3 h ago", "2 d ago", else the date. */
export function ago(ms: number, now = Date.now()): string {
  const s = (now - ms) / 1000;
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86_400) return `${Math.floor(s / 3600)} h ago`;
  if (s < 7 * 86_400) return `${Math.floor(s / 86_400)} d ago`;
  return new Date(ms).toISOString().slice(0, 10);
}
